export default "__VITE_ASSET__DmYxvSb0__"